export const FACEBOOK_URL = 'http://www.facebook.com/powershopaustralia/';
export const YOUTUBE_URL = 'https://www.youtube.com/user/PowershopAustralia';
export const LINKEDIN_URL =
  'https://au.linkedin.com/company/powershop-australia';
export const TWITTER_URL = 'https://twitter.com/PowershopAus/';
export const INSTAGRAM_URL = 'https://www.instagram.com/powershopaus/';

export const FLUX_URL_DEV = 'https://qa.test.powershop.com.au/';
export const FLUX_URL_PROD = 'https://secure.powershop.com.au/';
export const SIGNUP_PATH = 'signup/personal_details';

export const COMPARE_PLANS_URL = '/compare-energy-plans';
export const TERMS_CONDITIONS_URL =
  'https://www.powershop.com.au/terms-and-conditions';
export const RATES_PRICING_URL = '/energy-rates-and-prices';
export const REQUEST_A_CALL_BACK = '/request-a-call-back';

export const RESIDENTIAL_SALES_PHONE_NO = '1800 312 700';
export const RESIDENTIAL_SERVICE_PHONE_NO = '1800 462 668';
export const BUSINESS_PHONE_NO = '1800 728 197';

export const REVALIDATE = 60;

export const NMI_SEARCH_ITEM = {
  id: 'nmi-search-item',
  name: '',
};

export const CONTACT_SEARCH_ITEM = {
  id: 'contact-search-item',
  name: '',
};

export const INVITE_TOKEN_PAGE_SLUGS = ['switchyourmates'];
export const INVITE_CODE_COOKIE = 'invitation_code';
export const PROMO_TITLE_COOKIE = 'promo';
export const PROMO_ID_COOKIE = 'promo-id';
export const PROMO_TERMS_URL_COOKIE = 'promo-terms-url';
export const EXIT_MODAL_HREF_COOKIE = 'exit-href';
export const EXIT_MODAL_PATH_COOKIE = 'exit-modal-path';

export const DIRECT_DEBIT_TERMS = [
  'I have the authority to operate on this bank account and, if the account is held jointly, I have made the other account holder aware of this Direct Debit Request',
  'By providing Powershop Australia Pty Ltd (Direct Debit User ID 438972) with a valid instruction with respect to this Direct Debit Request, I have understood and agreed to the terms and conditions governing the debit arrangements between Powershop Australia Pty Ltd and myself (or the company identified above, as applicable) as set out in this Request and in the Direct Debit Request Service Agreement',
  'I authorise these debits or charges to be made through the Bulk Electronic Clearing System (BECS) from the account held at the financial institution I have nominated above and acknowledge that any such debits or charges will be subject to the terms and conditions of the Direct Debit Request Service Agreement.',
];

export const CREDIT_DEBIT_TERMS = [
  'To confirm that the credit card or debit card details you enter are correct we carry out a pre-authorisation transaction for $1 against the card. This process does not actually charge your card, but simply checks that a $1 charge could be charged if requested.',
  'In most circumstances, the transaction should disappear off after a short time.',
  'With VISA debit cards however, we are aware that this transaction may be reapplied each day for up to 10 days after the transaction was initiated. Again, we have not actually charged this amount to your debit account, even though it may look like we have. This transaction will continue to show until VISA clear the transaction automatically.',
];

export const REVIEW_TERMS = [
  'By accepting these conditions, you are entering into an agreement with Powershop Australia Pty Ltd who sells you energy;',
  "you accept Powershop's Terms and Conditions of supply, including (if applicable) the Solar Terms and Conditions;",
  'you confirm that you are over 18 and that these details are correct, to the best of your knowledge;',
  'you accept that you will receive bills and other communications from Powershop via email. Electricity is billed monthly. Gas is billed every two months if your property is in Victoria and every three months for all other states we operate in;',
  'you may be contacted to check you understood and consented to your agreement;',
  "you may receive estimated bills if actual meter readings aren't available;",
  'you understand and acknowledge your prices or fees may change from time to time. You will be given notice of any changes in accordance with regulatory requirements;',
  "you understand that we will collect, use, hold and disclose your personal information (including disclosure to third parties) in accordance with Powershop's privacy policy. If you have given us someone else's details (as a secondary account holder), you have let them know that their information has been provided to us and told them about our privacy policy;",
  "you understand that Powershop may arrange for a credit check to be conducted on you. Where a credit check fails to meet Powershop's criteria, it may cancel this contract and not proceed with your switch or connection. Powershop collects, uses and discloses your credit information in accordance with its credit report policy;",
  'you are authorised to organise supply of power to this address;',
  'you understand that a representative may be paid a fee for this sale; and',
  'you understand that you have a 10-business day cooling off period during which you can cancel your contract, which starts the business day after you receive your welcome pack via email.',
];

export const SIGNUP_ERROR_MESSAGE =
  'There was a problem with your submission, please check the following errors and try again:';

export const SIGNUP_CONFIRMATION_URLS = {
  ROOT: '/sign-up/confirmation',
  EXISTING_MOVING: '/thank-you-existing-customer-move',
  EXISTING_ADD_PROPERTY: '/thank-you-existing-customer-add-property',
  NEW_MOVING: '/thank-you-new-customer-move',
  NEW_SWITCH: '/thank-you-new-customer-switch',
};

export const MODAL_NAMES = {
  OutsideServiceArea: 'OutsideServiceArea',
  MultipleAddress: 'MultipleAddress',
  ChangeAddressWarning: 'ChangeAddressWarning',
  NmiSearch: 'NmiSearch',
  AddressNotFound: 'AddressNotFound',
  GasAddressNotFound: 'GasAddressNotFound',
} as const;

export const ANALYTICS_EVENTS = {
  signup: {
    details: {
      submit: 'Join Details Step 1',
      mirnAdded: 'details_mirn_added',
      existingCustomerFlow: 'Existing customer flow',
      newCustomerFlow: 'New customer flow',
      lifeSupport: 'Life support dependent',
      lifeSupportModal: {
        openModal: 'Life support modal open',
        closeModal: 'Life support modal close',
        serviceCall: 'Life support modal: service call',
      },
      isExistingMember: 'Customer type selection',
      edgeCases: {
        detailsAlreadyExists: {
          openModal: 'Details already exist',
          backToDetails: 'Details already exist: Back to your details',
          existingCustomerSignup:
            'Details already exist: Existing customer sign up',
        },
        detailsMismatch: {
          openModal: 'Details mismatch',
          backToDetails: 'Details mismatch: Back to your details',
          serviceCall: 'Details mismatch: service call',
        },
        detailsNotRecognised: {
          openModal: 'Details not recognised',
          backToDetails: 'Details not recognised: Back to your details',
          newCustomerSignup: 'Details not recognised: New customer sign up',
        },
        invalidMirn: {
          error: 'details_mirn_error',
          emptyMirnRetry: 'details_mirn_override',
        },
      },
      changeAddress: 'Change address',
      changePlan: {
        clicked: 'Change plan clicked',
        serviceCall: 'Change plan: service call',
      },
      helpMeConnected: 'Help me connected: accepted',
      errors: 'Details: Form validation errors',
      apiError: 'Details: api validation error',
    },
    billing: {
      submit: 'Join Payment Step 2',
      directDebitTerms: {
        view: 'View direct debit T&Cs',
        return: 'View direct debit T&Cs: return to form',
        accepted: 'View direct debit T&Cs: accepted',
      },
      errors: 'Billing: Form validation errors',
    },
    review: {
      submit: 'Join Confirmation Step 3',
      powershopTerms: {
        view: 'View Powershop terms of service',
        return: 'View Powershop terms of service: return to form',
        accepted: 'View Powershop terms of service: accepted',
      },
      edit: {
        details: 'Edit customer details',
        billing: 'Edit payment details',
      },
      errors: {
        api: 'Review: Error from Flux API',
        saleSubmissionError: 'sale_submission_error',
      },
    },
    confirmation: 'Sign up event',
    apps: {
      ios: 'App Store redirect from Sign up',
      android: 'Play Store redirect from Sign up',
    },
    powerpack: 'See Powerpack redirect from Sign up',
    exitConfirmation: {
      stayOnPage: 'Exit confirmation modal: stay on page',
      leaveForm: 'Exit confirmation modal: leave form',
      closeModal: 'Exit confirmation modal: close modal',
    },
  },
  checkboxesSelections: {
    electricity_quote_flow_selected: 'electricity_quote_flow_selected',
    dual_fuel_quote_flow_selected: 'dual_fuel_quote_flow_selected',
    gas_quote_flow_selected: 'gas_quote_flow_selected',
    electricity_quote_flow_selected_cep: 'electricity_quote_flow_selected_cep',
    dual_fuel_quote_flow_selected_cep: 'dual_fuel_quote_flow_selected_cep',
    gas_quote_flow_selected_cep: 'gas_quote_flow_selected_cep',
    electricity_quote_flow_selected_cp: 'electricity_quote_flow_selected_cp',
    dual_fuel_quote_flow_selected_cp: 'dual_fuel_quote_flow_selected_cp',
    gas_quote_flow_selected_cp: 'gas_quote_flow_selected_cp',
  },
  compareEnergyPlans: {
    pricesDisplayed: 'Compare Energy Plans page: prices displayed',
    pageLanded: 'plans_page',
    planSelected: 'planSelected',
    postcodeSearch: 'postcodeSearch',
    dualFuelSelected: 'Dual Fuel quote flow selected',
    electricitySelected: 'Electricity quote flow selected',
    fuelNotRequired: {
      electricity: `don't require electricity`,
      gas: `don't require gas`,
    },
    crossSell: {
      electricity: {
        view: 'View electricity plans - cross sell',
        decline: 'Decline electricity plans - cross sell',
      },
      gas: {
        view: 'View gas plans - cross sell',
        decline: 'Decline gas plans - cross sell',
      },
    },
    preferences: {
      solarPanel: {
        select: 'preference solar panel select',
        deselect: 'preference solar panel deselect',
      },
      electricVehicle: {
        select: 'preference electric vehicle select',
        deselect: 'preference electric vehicle deselect',
      },
      carbonNeutral: {
        select: 'preference carbon neutral select',
        deselect: 'preference carbon neutral deselect',
      },
    },
    estimatedPrice: {
      yearly: 'estimated price yearly',
      quarterly: 'estimated price quarterly',
      monthly: 'estimated price monthly',
      weekly: 'estimated price weekly',
    },
  },
  campaignPage: {
    postcodeSearch: 'postcodeSearch',
    postcodeSearchCampaignPage: 'postcodeSearchCampaignPage',
    pricesDisplayed: 'Campaign page: prices displayed',
    planSelected: 'planSelected',
    estimatedPrice: {
      yearly: 'estimated_price_yearly_cp',
      quarterly: 'estimated_price_quarterly_cp',
      monthly: 'estimated_price_monthly_cp',
      weekly: 'estimated_price_weekly_cp',
    }
  },
  hero: {
    postCodeSearch: 'postcodeSearch',
  },
  oneBigSwitchModal: {
    openModal: 'One Big Switch modal open',
    viewAllPlans: 'One Big Switch modal: view all plans',
    keepCurrentOffer: 'One Big Switch modal: keep current offer',
  },
  evRequirementsModal: {
    openModalExisitngCustomer: 'EV requirements modal open: existing customer',
    openModalNewCustomer: 'EV requirements modal open: new customer',
    callExisitngCustomer: 'EV requirements modal: existing customer call',
    callNewCustomer: 'EV requirements modal: new customer call',
  },
  evExistingCustomerModal: {
    modalOpen: 'EV Existing Customer modal open',
    goToForm: 'EV Existing Customer modal: go to form',
  },
  addressNotFoundModal: {
    modalOpen: 'Address Not Found Modal - Open',
    modalClose: 'Address Not Found Modal - Close',
    callResidential: 'Address Not Found Modal - Call Residential',
    callBusiness: 'Address Not Found Modal - Call Business',
    nmiLookup: 'Address Not Found Modal - NMI Lookup',
    userTypeSelected: 'address_not_found',
  },
  multipleAddressModal: {
    postcodeSearch: 'postcodeSearch',
  },
  nmiSearchModal: {
    nmiLookup: 'NMI Lookup',
    manualSearch: 'nmi_manual_search',
  },
  outsideOfServiceAreaModal: {
    modalOpen: 'Outside service area modal - Open',
    modalClose: 'Outside service area modal - Close',
    backToHomeClicked: 'Outside service area modal - Back to home',
    call: 'Outside service area modal - Call',
  },
  quickLinks: {
    selected: 'Quick links block item selected',
  },
  headerDropdown: {
    selected: 'Header menu item selected',
  },
  gasNotOffered: 'error gas not offered',
};

export const PUBLIC_HOLIDAYS = {
  VIC: [
    '2024-06-10',
    '2024-09-27',
    '2024-11-05',
    '2024-12-25',
    '2024-12-26',
    '2025-01-01',
    '2025-01-27',
    '2025-03-10',
    '2025-04-18',
    '2025-04-19',
    '2025-04-20',
    '2025-04-21',
    '2025-04-25',
    '2025-06-09',
    '2025-11-04',
    '2025-12-25',
    '2025-12-26',
  ],
  NSW: [
    '2024-06-10',
    '2024-08-05',
    '2024-10-07',
    '2024-12-25',
    '2024-12-26',
    '2025-01-01',
    '2025-01-27',
    '2025-04-18',
    '2025-04-19',
    '2025-04-20',
    '2025-04-21',
    '2025-04-25',
    '2025-06-09',
    '2025-08-04',
    '2025-10-06',
    '2025-12-25',
    '2025-12-26',
  ],
  QLD: [
    '2024-08-14',
    '2024-10-07',
    '2024-12-25',
    '2024-12-26',
    '2025-01-01',
    '2025-01-27',
    '2025-04-18',
    '2025-04-19',
    '2025-04-20',
    '2025-04-21',
    '2025-04-25',
    '2025-05-05',
    '2025-08-13',
    '2025-10-06',
    '2025-12-25',
    '2025-12-26',
  ],
  SA: [
    '2024-06-10',
    '2024-10-07',
    '2024-12-25',
    '2024-12-26',
    '2025-01-01',
    '2025-01-27',
    '2025-03-10',
    '2025-04-18',
    '2025-04-19',
    '2025-04-20',
    '2025-04-21',
    '2025-04-25',
    '2025-06-09',
    '2025-10-06',
    '2025-12-25',
    '2025-12-26',
  ],
};

export const offerHeading =
  'Get up to $300 credit by combining selected energy plans*';

export const offerDescription =
  'Get $150 electricity credit + $150 gas credit on your first bill when you sign up for selected energy plans*';

export const offerDescriptionGas =
  'Get $150 electricity credit on your first bill when you sign up for selected electricity plans*';

export const pageCollectionLimit = 300;

export const ENABLE_CAMPAIGNS: true | false = true;
export const EXCLUDED_CAMPAIGNS = ['switchyourmates'];
